import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import gdpr from '../views/gdpr.vue'
import imprint from '../views/imprint.vue'
import blog from '../views/blog.vue'
import p1 from '../views/p1.vue'
import terraformstatefile from '../views/terraform-statefile.vue'
import terraformstatefilegcp from '../views/terraform-statefile-gcp.vue'
import terraformstatefileaws from '../views/terraform-statefile-aws.vue'
import terraformstatefileazure from '../views/terraform-statefile-azure.vue'
import rcloneionos from '../views/rclone-ionos.vue'
import azurewi from '../views/azure-wi.vue'
import aksagfc from '../views/aks-agfc.vue'
import infraModule from '../views/infra-module.vue'
import ytSummariser from '../views/yt-summariser.vue'
import g1Assistant from '../views/g1-assistant.vue'
import xpBase from '../views/xp-base.vue'
import g1Dns from '../views/g1-dns.vue'
import g1Mail from '../views/g1-mail.vue'
import mailserverAnsible from '../views/mailserver-ansible.vue'
import kcpPot from '../views/kcp-pot.vue'
import cncfLab from '../views/CNCF-lab.vue'
import debianAutomatedInstallation from '../views/debian-automated-installation.vue'
import vibeCoding from '../views/vibe-coding.vue'
import installArchify from '../views/install-archify.vue'
import beatDrift from '../views/beat-drift.vue'
import beatDrift2 from '../views/beat-drift-2.vue'
import beatDrift3 from '../views/beat-drift-3.vue'
import beatDrift4 from '../views/beat-drift-4.vue'
import beatDrift5 from '../views/beat-drift-5.vue'
import beatDrift6 from '../views/beat-drift-6.vue'
import mptcp from '../views/mptcp.vue'
import staff from '../views/staff.vue'
import matomotraefik from '../views/matomo-traefik.vue'
import pvchat from '../views/pv-chat.vue'
import quirionchat from '../views/quirion-chat.vue'
import witz01 from '../views/witz01.vue'
import chatindex from '../views/chat-index.vue'
import offlineChoice from '../views/offline-choice.vue'
import links from '../helpers/links'
import isOnline from '../helpers/online'
import track from '../helpers/track'
import i18n from '../i18n'
import { useMainStore } from '@/stores'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/blog',
    name: 'blog',
    component: blog
  },
  {
    path: '/unavailable',
    name: 'offline-choice',
    component: offlineChoice,
    meta: { noindex: true }
  },
  {
    path: '/team',
    name: 'staff',
    component: staff,
    meta: { noindex: true }
  },
  {
    path: '/p1',
    name: 'p1',
    component: p1
  },
  {
    path: '/terraform-statefile',
    name: 'terraform-statefile',
    component: terraformstatefile
  },
  {
    path: '/chat-index',
    name: 'chat-index',
    component: chatindex
  },
  {
    path: '/pv-chat',
    name: 'pv-chat',
    component: pvchat
  },
  {
    path: '/quirion-chat',
    name: 'quirion-chat',
    component: quirionchat
  },
  {
    path: '/witz01',
    name: 'witz01',
    component: witz01
  },
  {
    path: '/terraform-statefile-gcp',
    name: 'terraform-statefile-gcp',
    component: terraformstatefilegcp
  },
  {
    path: '/terraform-statefile-aws',
    name: 'terraform-statefile-aws',
    component: terraformstatefileaws
  },
  {
    path: '/terraform-statefile-azure',
    name: 'terraform-statefile-azure',
    component: terraformstatefileazure
  },
  {
    path: '/rclone-ionos',
    name: 'rclone-ionos',
    component: rcloneionos
  },
  {
    path: '/azure-wi',
    name: 'azure-wi',
    component: azurewi
  },
  {
    path: '/aks-agfc',
    name: 'aks-agfc',
    component: aksagfc
  },
  {
    path: '/infra-module',
    name: 'infra-module',
    component: infraModule
  },
  {
    path: '/yt-summariser',
    name: 'yt-summariser',
    component: ytSummariser
  },
  {
    path: '/g1-yt-summariser',
    redirect: '/yt-summariser'
  },
  {
    path: '/g1-assistant',
    name: 'g1-assistant',
    component: g1Assistant
  },
  {
    path: '/xp-base',
    name: 'xp-base',
    component: xpBase
  },
  {
    path: '/g1-dns',
    name: 'g1-dns',
    component: g1Dns
  },
  {
    path: '/g1-mail',
    name: 'g1-mail',
    component: g1Mail
  },
  {
    path: '/mailserver-ansible',
    name: 'mailserver-ansible',
    component: mailserverAnsible
  },
  {
    path: '/kcp-pot',
    name: 'kcp-pot',
    component: kcpPot
  },
  {
    path: '/CNCF-lab',
    name: 'CNCF-lab',
    component: cncfLab
  },
  {
    path: '/debian-automated-installation',
    name: 'debian-automated-installation',
    component: debianAutomatedInstallation
  },
  {
    path: '/install-archify',
    name: 'install-archify',
    component: installArchify
  },
  {
    path: '/beat-drift',
    name: 'beat-drift',
    component: beatDrift
  },
  {
    path: '/beat-drift-2',
    name: 'beat-drift-2',
    component: beatDrift2
  },
  {
    path: '/beat-drift-3',
    name: 'beat-drift-3',
    component: beatDrift3
  },
  {
    path: '/beat-drift-4',
    name: 'beat-drift-4',
    component: beatDrift4
  },
  {
    path: '/beat-drift-5',
    name: 'beat-drift-5',
    component: beatDrift5
  },
  {
    path: '/beat-drift-6',
    name: 'beat-drift-6',
    component: beatDrift6
  },
  {
    path: '/mptcp',
    name: 'mptcp',
    component: mptcp
  },
  {
    path: '/vibe-coding',
    name: 'vibe-coding',
    component: vibeCoding
  },
  {
    path: '/matomo-traefik',
    name: 'matomo-traefik',
    component: matomotraefik
  },
  {
    path: '/gdpr',
    name: 'gdpr',
    component: gdpr
  },
  {
    path: '/imprint',
    name: 'imprint',
    component: imprint
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( '../views/AboutView.vue')
  }/*,
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import( '../views/AboutView.vue')
  }
*/
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// A post switched off via `online: false` frontmatter in the current locale is
// not shown; the visitor gets a choice page (blog / other language) instead.
router.beforeEach((to, from, next) => {
  if (to.name && to.name !== 'offline-choice' && !isOnline(to.name, i18n.locale)) {
    next({ name: 'offline-choice', query: { post: to.name }, replace: true })
  } else {
    next()
  }
})

// Keep the navbar's active-link highlight in sync with routes that are pages
// of their own (blog, gdpr, imprint, home) rather than in-page anchors
// (products, references) — those are instead tracked by HomeView's scroll
// listener while the route stays 'home'.
router.afterEach((to) => {
  if (links.some(link => link.name === to.name)) {
    const stores = useMainStore()
    stores.setActiveSection(to.name)
  }
})

// Routes with `meta: { noindex: true }` get a robots noindex tag while shown;
// it is removed again on navigating away, since all routes share index.html.
router.afterEach((to) => {
  let tag = document.head.querySelector('meta[name="robots"]')
  if (to.meta.noindex && !tag) {
    tag = document.createElement('meta')
    tag.name = 'robots'
    tag.content = 'noindex'
    document.head.appendChild(tag)
  } else if (!to.meta.noindex && tag) {
    tag.remove()
  }
})

track(router)

export default router
